import { render } from "./BaseForm.vue?vue&type=template&id=786e5bf1&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"

import "./BaseForm.vue?vue&type=style&index=0&id=786e5bf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786e5bf1"]])

export default __exports__